import { render } from "./DkBotMessage.vue?vue&type=template&id=6ab99f48"
import script from "./DkBotMessage.vue?vue&type=script&lang=js"
export * from "./DkBotMessage.vue?vue&type=script&lang=js"

import "./DkBotMessage.vue?vue&type=style&index=0&id=6ab99f48&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__